


























import Vue from 'vue';
import { VAppBar, VSpacer } from 'vuetify/lib';

export default Vue.extend({
  components: { VAppBar, VSpacer },
  methods: {
    routeTo(link: string) {
      this.$router.push(`${link}`).catch(() => {
        //
      });
    }
  },
  props: {
    company: {
      type: String
    },
    description: {
      type: String
    },
    logo: {
      required: false
    },
    logoURL: {
      type: String,
      default: '/'
    },
    color: {
      type: String,
      default: 'secondary'
    }
  }
});
